import React from "react";
import { normalizeGameUiConfig } from "./gamePresentation";

export default function GameModuleFrame({
  moduleId,
  defaults,
  uiConfig,
  fallbackTextureUrl,
  capabilities,
  children,
}) {
  const overrides = normalizeGameUiConfig(uiConfig);
  const presentation = { ...defaults };

  Object.entries(overrides).forEach(([key, value]) => {
    if (value !== undefined) presentation[key] = value;
  });

  const backgroundTextureUrl = presentation.backgroundTextureUrl || fallbackTextureUrl;
  const screenTextureUrl = presentation.screenTextureUrl;
  const panelTextureUrl = presentation.panelTextureUrl;

  return (
    <div
      data-game-module={moduleId}
      data-game-capabilities={Object.keys(capabilities || {}).filter((key) => capabilities[key]).join(" ")}
      style={{
        minHeight: "100%",
        color: presentation.textColor,
        backgroundColor: presentation.backgroundColor,
        backgroundImage: backgroundTextureUrl ? `url(${backgroundTextureUrl})` : "none",
        "--game-background-color": presentation.backgroundColor,
        "--game-surface-color": presentation.surfaceColor,
        "--game-text-color": presentation.textColor,
        "--game-accent-color": presentation.accentColor,
        "--game-texture-opacity": presentation.textureOpacity,
        "--game-screen-texture": screenTextureUrl ? `url(${screenTextureUrl})` : "none",
        "--game-panel-texture": panelTextureUrl ? `url(${panelTextureUrl})` : "none",
      }}
    >
      {children}
    </div>
  );
}
